import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import heroBg from '../assets/images/HeroBanner.png';
import '../styles/EDCCTermsConditions.css';
import { useNavigate } from 'react-router-dom';

const EDCCTermsAndConditions = () => {
    const navigate = useNavigate();
    const [isAgreed, setIsAgreed] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [viewerLoaded, setViewerLoaded] = useState(false);
    const [useFastViewer, setUseFastViewer] = useState(true);

    // const pdfUrl = 'https://aiotadev.s3.ap-south-1.amazonaws.com/uploads/1759559428155-AIOTA%20Regulation%20for%20CERTIFICATION%20%28Guidelines%29%202024-2028%20%281%29.pdf';
    const pdfUrl = 'https://aiotadev.s3.ap-south-1.amazonaws.com/uploads/1776842633466-AIOTA%20Regulation%20for%20CERTIFICATION%20%28Guidelines%29%202024-2028.pdf';


    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        // Preload PDF.js viewer for faster loading
        const preloadViewer = () => {
            if (!viewerLoaded) {
                const viewerIframe = document.createElement('iframe');
                viewerIframe.style.display = 'none';
                viewerIframe.src = `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`;
                document.body.appendChild(viewerIframe);
                setTimeout(() => {
                    document.body.removeChild(viewerIframe);
                    setViewerLoaded(true);
                }, 1000);
            }
        };

        // Load after initial render
        setTimeout(preloadViewer, 500);

        return () => window.removeEventListener('resize', checkMobile);
    }, [viewerLoaded, pdfUrl]);

    const handleCheckboxChange = (e) => {
        setIsAgreed(e.target.checked);
    };

    const handleNotNowClick = () => {
        navigate("/");
    };

   const getFastPdfViewerUrl = () => {
    // Direct browser PDF rendering (no CORS issues)
    return `${pdfUrl}#zoom=page-width`;
};


    const getGoogleViewerUrl = () => {
        return `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(pdfUrl)}`;
    };

    const toggleViewer = () => {
        setUseFastViewer(!useFastViewer);
        setIsLoading(true);
    };

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    return (
        <>
            {/* Fixed Hero Section */}
            <section
                className="hero-fixed"
                style={{ backgroundImage: `url(${heroBg})` }}>
                <div className="hero-scroll-content">
                    <div className="hero-content-home poppins-regular">
                        <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
                    </div>
                </div>
            </section>

            {/* Scrollable Content Container */}
            <div className="scrollable-content-home">
                <div className="content-container">
                    <Container className="terms-container py-3 py-md-5">
                        <h3 className="text-center mb-3 mb-md-4" style={{
                            fontSize: isMobile ? '1.5rem' : '1.75rem'
                        }}>
                            Terms and conditions
                        </h3>
                        <p style={{
                            fontSize: isMobile ? '0.9rem' : '1rem',
                            lineHeight: '1.6'
                        }}>
                            Before starting your EDCC registration, it is important to read the guidelines provided below. These instructions contain the necessary steps and requirements for a smooth registration. The registration process will only begin after you have carefully reviewed the guidelines. Please ensure you go through them completely before proceeding further.
                        </p>

                        {/* Quick Action Buttons */}
                        {/* <div className="d-flex justify-content-center gap-2 mb-3 flex-wrap">
                            <a 
                                href={pdfUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-success btn-sm"
                                style={{
                                    fontSize: isMobile ? '0.8rem' : '0.875rem'
                                }}
                            >
                                ⚡ Quick Open PDF
                            </a>
                            <a 
                                href={pdfUrl}
                                download="AIOTA_Guidelines.pdf"
                                className="btn btn-outline-success btn-sm"
                                style={{
                                    fontSize: isMobile ? '0.8rem' : '0.875rem'
                                }}
                            >
                                📥 Download First
                            </a>
                        </div> */}

                        {/* PDF Viewer Container - Responsive */}
                        <div className="pdf-container mb-3 mb-md-4" style={{
                            width: '100%',
                            height: isMobile ? '60vh' : '75vh',
                            minHeight: isMobile ? '400px' : '500px',
                            maxHeight: '1000px',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            backgroundColor: '#f8f9fa',
                            position: 'relative'
                        }}>
                            {/* Loading Spinner */}
                            {isLoading && (
                                <div className="d-flex align-items-center justify-content-center h-100">
                                    <div className="text-center">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading PDF Viewer...</p>
                                    </div>
                                </div>
                            )}

                            {/* PDF Viewer */}
                            <iframe
                                src={useFastViewer ? getFastPdfViewerUrl() : getGoogleViewerUrl()}
                                width="100%"
                                height="100%"
                                title="Terms and Conditions PDF"
                                style={{
                                    border: 'none',
                                    display: isLoading ? 'none' : 'block'
                                }}
                                onLoad={handleIframeLoad}
                                loading="eager"
                                allow="fullscreen"
                                referrerPolicy="no-referrer"
                            />
                        </div>

                        {/* Viewer Info and Toggle */}
                        {/* <div className="d-flex justify-content-between align-items-center mb-3 px-2">
                            <div>
                                <small className="text-success" style={{
                                    fontSize: isMobile ? '0.75rem' : '0.875rem'
                                }}>
                                    <strong>Using: {useFastViewer ? 'Fast PDF.js Viewer' : 'Google Docs Viewer'}</strong>
                                </small>
                            </div>
                            <div>
                                <button 
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={toggleViewer}
                                    style={{
                                        fontSize: isMobile ? '0.75rem' : '0.875rem',
                                        padding: '3px 10px'
                                    }}
                                >
                                    Switch to {useFastViewer ? 'Google' : 'PDF.js'}
                                </button>
                            </div>
                        </div> */}

                        {/* Loading Tips */}
                        {/* <div className="alert alert-info mb-3" style={{
                            fontSize: isMobile ? '0.85rem' : '0.9rem',
                            padding: isMobile ? '10px' : '15px'
                        }}>
                            <div className="d-flex align-items-start">
                                <div className="me-2">💡</div>
                                <div>
                                    <strong>For faster loading:</strong>
                                    <ul className="mb-0 mt-1">
                                        <li>Click <strong>"Quick Open PDF"</strong> to open directly in browser</li>
                                        <li>Click <strong>"Download First"</strong> then open from your device</li>
                                        <li>Switch to <strong>PDF.js viewer</strong> for better performance</li>
                                    </ul>
                                </div>
                            </div>
                        </div> */}

                        {/* Alternative link - Mobile friendly */}
                        <div className="text-center mb-3">
                            <small className="text-muted" style={{
                                fontSize: isMobile ? '0.8rem' : '0.875rem',
                                display: 'block',
                                padding: '0 10px'
                            }}>
                                Having trouble viewing? {' '}
                                <a 
                                    href={pdfUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none fw-bold"
                                >
                                    Open PDF in a new tab
                                </a>
                                {' '} • {' '}
                                <a 
                                    href={pdfUrl}
                                    download="AIOTA_Certification_Guidelines.pdf"
                                    className="text-decoration-none fw-bold"
                                >
                                    Download PDF
                                </a>
                            </small>
                        </div>

                        {/* Checkbox - Responsive */}
                        <div className="text-left mt-3 mt-md-4" style={{
                            padding: isMobile ? '0 10px' : '0'
                        }}>
                            <div className="d-flex" style={{ alignItems: 'flex-start' }}>
                                <input 
                                    type="checkbox" 
                                    id="agree" 
                                    checked={isAgreed}
                                    onChange={handleCheckboxChange}
                                    className="flex-shrink-0"
                                    style={{ 
                                        minWidth: isMobile ? '18px' : '16px',
                                        height: isMobile ? '18px' : '16px',
                                        marginTop: '2px',
                                        cursor: 'pointer'
                                    }}
                                />
                                <label 
                                    htmlFor="agree" 
                                    className="ms-2 mb-0" 
                                    style={{ 
                                        flex: 1, 
                                        wordBreak: 'break-word', 
                                        lineHeight: '1.4',
                                        fontSize: isMobile ? '0.9rem' : '1rem',
                                        cursor: 'pointer'
                                    }}
                                >
                                    I have read and accepted all terms and conditions
                                </label>
                            </div>
                        </div>

                        {/* Buttons - Responsive */}
                        <div className="text-center mt-3 mt-md-4" style={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            justifyContent: 'center',
                            gap: isMobile ? '10px' : '0',
                            padding: isMobile ? '0 10px' : '0'
                        }}>
                            <button 
                                className="btn btn-secondary notrightnow-btn" 
                                onClick={handleNotNowClick}
                                style={{
                                    marginRight: isMobile ? '0' : '0.5rem',
                                    width: isMobile ? '100%' : 'auto',
                                    fontSize: isMobile ? '0.9rem' : '1rem',
                                    padding: isMobile ? '10px 20px' : '0.375rem 0.75rem'
                                }}
                            >
                                Not Right Now
                            </button>
                            <button 
                                className="btn btn-primary" 
                                onClick={() => navigate('/edccform')}
                                disabled={!isAgreed}
                                style={{
                                    width: isMobile ? '100%' : 'auto',
                                    fontSize: isMobile ? '0.9rem' : '1rem',
                                    padding: isMobile ? '10px 20px' : '0.375rem 0.75rem'
                                }}
                            >
                                I Agree
                            </button>
                        </div>
                    </Container>
                </div>
            </div>
        </>
    );
};

export default EDCCTermsAndConditions;